import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { invite } from "../../../api/user";
import { setFlashNotification } from "../../../redux/modules/flashNotification";
import { isValidEmail, formatPhoneNumber, formatDateInMDY, deepClone, getFilterByKey } from "../../../legacy/utils/helpers";
import AppButton from "../../base/Button/Button";
import "./InviteClientCA.scss";
import Input from "../../base/Input/Input";
import { AppConstant } from "src/latest/src";
import DatePicker from "src/containers/QuestionnaireParent/QuestionOptionsLibrary/components/DatePicker/DatePicker";
import { Typography } from "src/latest/src/components";
import { existingUser } from "src/redux/services/loggingServices";
import { differenceInYears } from 'date-fns';
import { noop } from "react-bootstrap-typeahead/types/utils";

const InviteClientCA = ({
    type,
    getList = noop,
    currentPage,
    onChangeClientModalRender = noop,
    setCloseModalAndRedirect,
    slotDetails = {},
}) => {
    const insuranceFilters: any = useSelector(
        (state: any) => state?.questionnaireData?.currentConfig?.combinedFilters?.filters
    );
    const filtersArray = useSelector(
        (state) => state?.questionnaireData?.currentConfig?.combinedFilters?.filters
    );
    const locationFilter = filtersArray && getFilterByKey(filtersArray, "clientLocation");

    const dispatch = useDispatch();
    const clientInputs = {
        email: "",
        first_name: "",
        last_name: "",
        phone_no: "",
        birth_date: "",
        user_type: ["CLIENT"],
        slot_details: slotDetails,
        required_insurance: false,
        required_credit_card:true,
        pre_onboarded_by_scheduler: null
    };
    const [userDetails, setUserDetails] = useState(clientInputs);
    const [isExistingUser, setIsExistingUser] = useState(false);
    const [CheckClientAge, setCheckClientAge] = useState(null);
    const [isClientAgeMismatch, setIsClientAgeMismatch] = useState(false);
    const [hasInsuranceData, setHasInsuranceData] = useState(false);
    const [isDisable, setIsDisable] = useState(true);
    const [isInValidInput, setIsInValidInput] = useState({
        phone_no: false,
        email: false,
    });
    const [inputFeedbackMessage, setInputFeedbackMessage] = useState({
        phone_no: "",
        email: "",
    });
    const [isProcessing, setIsProcessing] = useState(false);
    const tenantBackgroundColor = useSelector(
        (state) => state?.configuration?.tenantBackgroundColor
    );

    const { practiceTimeZone, practiceTimeZoneKey } = useSelector(
        (state: any) => state?.configuration
    );
  
    useEffect(() => {
        if (insuranceFilters?.length) {
            const insuranceData = insuranceFilters?.some(filter => filter?.filter_key === "insurancePlan");

            setHasInsuranceData(insuranceData);
        }
    }, [insuranceFilters]);

    useEffect(() => {
        setUserDetails(prevDetails => ({
            ...prevDetails,
            required_insurance: hasInsuranceData
        }));
    }, [hasInsuranceData]);

    const calculateClientAge = (birthDate) => {
        if (!birthDate) return null;
    
        const currentDate = new Date();
        const formattedBirthDate = new Date(birthDate);
    
        return differenceInYears(currentDate, formattedBirthDate);
    };
    
    const handleEmailBlur = async () => {

        if (isValidEmail(userDetails?.email)) {

            try {
                setIsProcessing(true);

                const result = await existingUser(userDetails?.email);

                const existingUserData = result?.users?.length ? result.users[0] : undefined;

                if (existingUserData) {
                    setUserDetails({
                        ...userDetails,
                        first_name: existingUserData.first_name,
                        last_name: existingUserData.last_name,
                        phone_no: existingUserData.telephone_number,
                        birth_date: formatDateInMDY(existingUserData.birth_date),
                        required_insurance: existingUserData.required_insurance,
                        required_credit_card: existingUserData.required_credit_card,
                        pre_onboarded_by_scheduler:existingUserData.pre_onboarded_by_scheduler
                    });

                    setInputFeedbackMessage({
                        ...inputFeedbackMessage,
                        phone_no: "",
                    });
                    setIsInValidInput({
                        ...isInValidInput,
                        phone_no: false,
                    });

                    setIsExistingUser(true);
                } else {
                    setInputFeedbackMessage({
                        ...inputFeedbackMessage,
                        email: "",
                    });
                    setIsInValidInput({
                        ...isInValidInput,
                        email: false,
                    });
                    setInputFeedbackMessage({
                        ...inputFeedbackMessage,
                        phone_no: "",
                    });
                    setIsInValidInput({
                        ...isInValidInput,
                        phone_no: false,
                    });
                    setIsExistingUser(false);
                    setUserDetails({ ...clientInputs, email: userDetails.email , required_insurance: hasInsuranceData});
                }

                setIsProcessing(false);
            } catch (err) {
                
                console.error(err);
                setIsProcessing(false);
            }
        }
    };

    /**
     * onFormFieldValueChange
     * @param {*} event 
     */
    const onFormFieldValueChange = (event) => {
        const { name, value, type, checked } = event.target;

        const finalValue = name === "phone_no" ? formatPhoneNumber(value) : value;

        if (type === "checkbox") {
            setUserDetails({
                ...userDetails,
                [name]: checked
            });

            return;
        }

        if (type === "radio") {
            setUserDetails({
                ...userDetails,
                [name]: value === "Scheduler_onboarding_client"
            });
            
            return;
        }

        if (name === "birth_date") {
            setUserDetails({
                ...userDetails,
                [name]: value
            });

            return;
        }

        if (name === "email") {
            if (!isValidEmail(finalValue)) {
                setIsInValidInput({
                    ...isInValidInput,
                    email: true,
                });

                if (finalValue.length === 0) {
                    setInputFeedbackMessage({
                        ...inputFeedbackMessage,
                        email: "",
                    });
                    setIsInValidInput({
                        ...isInValidInput,
                        email: false,
                    });
                } else {
                    setInputFeedbackMessage({
                        ...inputFeedbackMessage,
                        email: "please enter valid email id",
                    });
                }
            } else {
                setInputFeedbackMessage({
                    ...inputFeedbackMessage,
                    email: "",
                });
                setIsInValidInput({
                    ...isInValidInput,
                    email: false,
                });
            }
        }

        if (name === "phone_no") {
            if (finalValue.length !== 10 + 4) {
                setIsInValidInput({
                    ...isInValidInput,
                    phone_no: true,
                });

                if (finalValue.length === 0) {
                    setInputFeedbackMessage({
                        ...inputFeedbackMessage,
                        phone_no: "",
                    });
                    setIsInValidInput({
                        ...isInValidInput,
                        phone_no: false,
                    });
                } else {
                    setInputFeedbackMessage({
                        ...inputFeedbackMessage,
                        phone_no: "Please enter a 10 digit phone number.",
                    });
                }
            } else {
                setIsInValidInput({
                    ...isInValidInput,
                    phone_no: false,
                });
                setInputFeedbackMessage({
                    ...inputFeedbackMessage,
                    phone_no: "",
                });
            }
        }

        setUserDetails({
            ...userDetails,
            [name]: finalValue,
        });
    };


    useEffect(() => {
        // clean-up function
        return () => {
            onChangeClientModalRender("");
        };
    }, []);

    /**
     * onFormSubmit
     * Here we validate and submit the form and call the _invite API
     */


    const onFormSubmit = async () => {
        try {
            setIsProcessing(true);

            const _clientData = deepClone(userDetails);
            const stateCode = locationFilter && JSON.parse(locationFilter?.filter_selection_data[0]?.value)?.stateCode;

            if (_clientData?.slot_details) {        
                _clientData.slot_details.user_time_zone = practiceTimeZone;
                _clientData.slot_details.user_time_zone_key = practiceTimeZoneKey;
            }

            const response = await invite({..._clientData, state_code: stateCode});

            dispatch(
                setFlashNotification({
                    message: response?.message || "Successfully invited user",
                })
            );
            await getList(type, currentPage);

            setUserDetails({ ...clientInputs });
            setIsProcessing(false);

            if(userDetails.pre_onboarded_by_scheduler === true){
                setCloseModalAndRedirect(true);
            } else{
                setCloseModalAndRedirect(false);
            }

        } catch (err) {
            const message = err?.response?.data?.message || "Failed to invite user";

            console.error(err);

            setIsProcessing(false);
            dispatch(
                setFlashNotification({
                    message,
                    isError: true,
                })
            );
        }
    };

    /**
     * isFormValid
     * return is form valid status
     * @returns 
     */
    
    const isFormValid = () => {
        const trimmedFirstName = userDetails?.first_name?.trim();
        const trimmedLastName = userDetails?.last_name?.trim();

        if (
            !isValidEmail(userDetails?.email) ||
            !(trimmedFirstName) ||
            !(trimmedLastName) ||
            !userDetails?.birth_date || userDetails?.pre_onboarded_by_scheduler === null
        ) {
            return setIsDisable(true);
        }

        setIsDisable(false);
    };

    // Validate form fields on field value change
    useEffect(() => {
        if (!isEmpty(userDetails)) isFormValid();
    }, [userDetails]);

    const disabledStyle = {
        backgroundColor: "#e9ecef",
        color: "#6c757d",
        cursor: "not-allowed"
    };

    const slotAgeType = slotDetails.slot_reason_type;

    useEffect(() => {
        if (userDetails?.birth_date) {
            const ClientAge = calculateClientAge(userDetails.birth_date);

            setCheckClientAge(ClientAge);
        } else {
            setCheckClientAge(null);  
        }
    }, [userDetails?.birth_date]);

    useEffect(() => {
        setIsClientAgeMismatch(
            ((CheckClientAge !== null) && ((CheckClientAge < 18) && slotAgeType.includes("Adult")) || ((CheckClientAge >= 18) && slotAgeType.includes("Minor")))

        );
    }, [[CheckClientAge, slotAgeType]]);

    return (
        <div
            className="invite-Client-CA"
            style={{
                backgroundColor:
                    tenantBackgroundColor ||
                    AppConstant.defaultAppBackgroundColor,
            }}
        >
            <div className="invite-user-form invite-user__content">
                <Input
                    name="email"
                    type="email"
                    className="invite-user__input"
                    placeholder="email address"
                    required={true}
                    value={userDetails?.email}
                    onChange={(e) => onFormFieldValueChange(e)}
                    onBlur={handleEmailBlur}
                    feedbackMessage={inputFeedbackMessage?.email}
                    isInvalid={isInValidInput?.email}
                    maxLength={100}
                />
                <Input
                    name="first_name"
                    className="invite-user__input mt-4"
                    placeholder="First Name"
                    value={userDetails?.first_name}
                    onChange={(e) => onFormFieldValueChange(e)}
                    maxLength={50}
                    disabled={isExistingUser || isProcessing}
                    style={isExistingUser || isProcessing ? disabledStyle : {}}
                />

                <Input
                    name="last_name"
                    className="invite-user__input mt-4 mb-4"
                    placeholder="Last Name"
                    value={userDetails?.last_name}
                    onChange={(e) => onFormFieldValueChange(e)}
                    maxLength={50}
                    disabled={isExistingUser || isProcessing}
                    style={isExistingUser || isProcessing ? disabledStyle : {}}
                />
                <div className="inviteClient_Datepicker mt-4 mb-4">
                    <DatePicker
                        feedbackClassName="ms-2"
                        name="birth_date"
                        inputValue={userDetails?.birth_date}
                        onChange={(date) =>
                            onFormFieldValueChange({
                                target: { name: "birth_date", value: date },
                            })
                        }
                        infoMessage=""
                        placeholder="MM-DD-YYYY"
                        className="invite-user__datepicker"
                        onlyYear={false}
                        disabled={isExistingUser || isProcessing}
                        style={isExistingUser || isProcessing ? disabledStyle : {}}
                    />
                    {isClientAgeMismatch && (
                        <p className="client-age-message text-danger fs-6 fw-bold text-start ms-1 mt-2">
                            Age mismatch with the slot, choose <br /> another
                            slot{" "}
                        </p>
                    )}
                </div>
                <Input
                    name="phone_no"
                    type="tel"
                    className="invite-user__input mb-4 mt-3"
                    placeholder="phone number (optional)"
                    value={userDetails?.phone_no}
                    onChange={(e) => onFormFieldValueChange(e)}
                    feedbackMessage={inputFeedbackMessage?.phone_no}
                    isInvalid={isInValidInput?.phone_no}
                    disabled={isExistingUser || isProcessing}
                    style={isExistingUser || isProcessing ? disabledStyle : {}}
                />

                <div className="form-check mb-2 ms-1 invite-user__mt">
                    <input
                        className="form-check-input me-3"
                        type="checkbox"
                        name="required_insurance"
                        id="required_insurance"
                        checked={userDetails.required_insurance}
                        onChange={(e) => onFormFieldValueChange(e)}
                        disabled={isExistingUser || isProcessing}
                    />
                    <label
                        className="form-check-label"
                        htmlFor="required_insurance"
                    >
                        <Typography
                            className="Required-text ms-5"
                            variant="size-16"
                        >
                            {" "}
                            Collect insurance for this patient
                        </Typography>
                    </label>
                </div>
                <div className="form-check mb-4 ms-1 ">
                    <input
                        className="form-check-input me-3"
                        type="checkbox"
                        name="required_credit_card"
                        id="required_credit_card"
                        checked={userDetails.required_credit_card}
                        onChange={(e) => onFormFieldValueChange(e)}
                        disabled={isExistingUser || isProcessing}
                    />
                    <label
                        className="form-check-label"
                        htmlFor="required_credit_card"
                    >
                        <Typography
                            className="Required-text-creditcard ms-5"
                            variant="size-16"
                        >
                            {" "}
                            Collect credit card for this patient
                        </Typography>
                    </label>
                </div>

                <div className="form-check mb-4 ms-1 mt-3">
                    <Typography
                        variant="size-16"
                        className="mb-2 Onboarding-Oqptions ms-1 text-start"
                    >
                        Onboarding Options
                    </Typography>
                    <div>
                        <input
                            className="form-check-input"
                            type="radio"
                            name="pre_onboarded_by_scheduler"
                            id="Scheduler_onboarding_client"
                            value="Scheduler_onboarding_client"
                            checked={
                                userDetails.pre_onboarded_by_scheduler === true
                            }
                            onChange={(e) => onFormFieldValueChange(e)}
                            disabled={isExistingUser || isProcessing}
                        />
                        <label
                            className="form-check-label me-5 radiolabel2"
                            htmlFor="Scheduler_onboarding_client"
                        >
                            I will onboard this patient now
                        </label>
                    </div>
                    <div>
                        <input
                            className="form-check-input"
                            type="radio"
                            name="pre_onboarded_by_scheduler"
                            id="Client_onboard_themself"
                            value="Client_onboard_themself"
                            checked={
                                userDetails.pre_onboarded_by_scheduler === false
                            }
                            onChange={(e) => onFormFieldValueChange(e)}
                            disabled={isExistingUser || isProcessing}
                        />
                        <label
                            className="form-check-label radioLabel1 me-5"
                            htmlFor="Client_onboard_themself"
                        >
                            Invite patient to onboard themself
                        </label>
                    </div>
                </div>

                <div className="invite-btn">
                    <AppButton
                        label={isExistingUser ? "Book Appointment" : "Continue"}
                        isProcessing={isProcessing}
                        className="invite-user__button invite-staff-btn primary no-border"
                        textSize="size-14"
                        onClick={onFormSubmit}
                        disabled={
                            isDisable ||
                            inputFeedbackMessage?.phone_no !== "" ||
                            isProcessing ||
                            isClientAgeMismatch
                        }
                    />
                   
                </div>
            </div>
        </div>
    );
};

export default InviteClientCA;